export const getEntityGroups = state => state.entityGroups.list;
export const getSelectedEntityGroup = state => state.entityGroups.selected;
